module.exports = __webpack_public_path__ + "static/media/chevron-right-blue.dcf5516e.svg";